(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ananta_loyalty_footer"] && !Shopify.designMode) return;
  try {
    (function () {
    var attempts = 0;
    var maxAttempts = 40;
    var poll = setInterval(function () {
      attempts++;
      var launcher = document.querySelector('.loloyal-launcher-box');
      var slot = document.getElementById('ar-loyalty-slot');
      if (launcher && slot) {
        slot.appendChild(launcher);
        clearInterval(poll);
      } else if (attempts >= maxAttempts) {
        clearInterval(poll);
      }
    }, 300);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ananta_pdp_extras"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var carousel = e.target.closest('[data-ar-review-carousel]');
    if (!carousel) return;
    var slides = carousel.querySelectorAll('.ar-pdp-reviews__slide');
    if (!slides.length) return;
    var current = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
    if (e.target.closest('.ar-pdp-reviews__arrow--next')) {
      slides[current].classList.remove('is-active');
      slides[(current + 1) % slides.length].classList.add('is-active');
    } else if (e.target.closest('.ar-pdp-reviews__arrow--prev')) {
      slides[current].classList.remove('is-active');
      slides[(current - 1 + slides.length) % slides.length].classList.add('is-active');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ananta_price_badge"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-price').forEach(function (block) {
      if (block.closest('.sticky-add-to-cart')) return;
      if (block.querySelector('.ar-price-badge')) return;
      var sale = block.querySelector('.price-item__group.price:not(.compare-at-price)');
      var compare = block.querySelector('.compare-at-price');
      if (!sale || !compare) return;
      var toNum = function (t) { return parseFloat(t.replace(/[^0-9.]/g, '')); };
      var saleNum = toNum(sale.textContent);
      var compareNum = toNum(compare.textContent);
      if (!compareNum || compareNum <= saleNum) return;
      var pct = Math.round(((compareNum - saleNum) / compareNum) * 100);
      var badge = document.createElement('span');
      badge.className = 'ar-price-badge';
      badge.textContent = 'Save ' + pct + '%';
      sale.insertAdjacentElement('afterend', badge);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
